<template>
    <div class="school-detail-box news-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/submitStudents' }">保送生</el-breadcrumb-item>
            <el-breadcrumb-item>招生动态</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-detail-content">
			<div v-if="total_data == -1">
				<ContentLoader v-for="item in 20" :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="50" width="1100" viewBox="0 0 1000 50">
					<rect x="0" y="10" width="170" height="25" />
					<rect x="1000" y="10" width="110" height="25" />
				</ContentLoader>
			</div>
			<div v-else>
				<div class="no-data-box" v-if="total_data == 0">
					<img src="../../assets/images/null.png" alt="没有数据">
					<p>暂无数据</p>
				</div>
				<el-row type="flex" justify="space-between" class="school-detail-zs" v-for="(item,index) in news_list" :key="index" @click.native="gotoPath('/recommendNewsDetail', item.id)" v-else>
					<el-col :span="20">{{ item.news_title }}</el-col>
					<el-col :span="4">{{ item.create_time }}</el-col>
				</el-row>
				<el-pagination
					background
					layout="prev, pager, next, jumper"
					:total="total_data" :page-size="page_size" @current-change="getNewsListHandler" v-if="total_data > 0" :current-page.sync="currentPage">
				</el-pagination>
			</div>
        </div>
    </div>
</template>

<script>
import { getNewsList } from '@/api/submit_students'
import { ContentLoader } from 'vue-content-loader'
export default {
	components: {
        ContentLoader
    },
	data() {
		return {
			news_list: [],
			total_data: -1,
			currentPage: 1,
			page_size: 20
		}
	},
	created() {
		this.getNewsListHandler()
	},
	methods: {
		getNewsListHandler() {
			getNewsList(this.currentPage, this.page_size).then(res => {
				this.total_data = res.data.total
				this.news_list = res.data.data
			})
		},
        gotoPath(path, id) {
            this.$router.push({
                path: path,
                query: {
                    id: id
                }
            })
        }
	}
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.news-detail-content {
		@include gwidth;
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
		padding: 48px 40px;
		margin-top: 24px;
		min-height: 400px;
		box-sizing: border-box;
		.el-col-20 {
			font-size: 16px;
			color: #2c2e33;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			word-break: break-all;
			padding-right: 20px;
			font-weight: 600;
			cursor: pointer;
		}
		.el-col-20:hover {
			color: #ff6524 !important;
		}
		.el-col-4 {
			font-size: 14px;
			color: #909399;
			text-align: right;
		}
		.school-detail-zs :not(:last-child) {
			margin-bottom: 27px;
		}
	}
</style>